/**
 * The initial value of Symbol.isConcatSpreadable is the well-known symbol @@isConcatSpreadable
 * https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
 */
export const symbolIsConcatSpreadable = () => Symbol("Symbol.isConcatSpreadable");
